import React from 'react';
import WithProcessError from 'hocs/WithProcessError';
import PropTypes from 'prop-types';

import Button from 'components/Button/Button';
import Popup from 'components/Popup/Popup';
import RichCard from 'components/RichCard/RichCard';

import useApi from 'utils/api';
import { useAuth } from 'utils/auth';
import { actions, rolesMap } from 'utils/permissions';

// @todo: Add indicator about unregistered user.

function TeamMember(props) {
    const api = useApi();
    const auth = useAuth();
    const companyId = auth?.company.id;

    const { memberData, onDeleted, processError } = props;
    const { id, name, role, email } = memberData;

    const [popup, setPopup] = React.useState(null);
    const [loading, setLoading] = React.useState(false);

    function handleConfirmDelete() {
        setLoading(true);
        api.deleteUserFromCompany(companyId, id)
            .then(result => {
                if (result?.user_id === id) {
                    onDeleted();
                }
            })
            .catch(error => {
                processError('Не получилось удалить пользователя', error);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    function handleDelete() {
        setPopup(
            <Popup
                title='Удалить пользователя'
                description='Вы действительно хотите удалить пользователя из комании?'
                confirmText='Удалить'
                confirmDanger={true}
                canCloseOutside={true}
                autoclose={true}
                onConfirm={handleConfirmDelete}
                onClosed={() => setPopup(null)}
            />
        );
    }

    function getMemberActions() {
        if (Number(Object.keys(rolesMap)[0]) === role) {
            return null;
        }

        return (
            <Button
                size={'s'}
                text={'Удалить'}
                level={'tertiary'}
                needPermission={actions.ADD_USER}
                loading={loading}
                onClick={handleDelete}
            />
        );
    }

    return (
        <>
            {popup}
            <RichCard
                title={name || email}
                description={rolesMap[role].label + (name ? ', ' + email : '')}
                bottom={getMemberActions()}
            />
        </>
    );
}

TeamMember.propTypes = {
    memberData: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        email: PropTypes.string,
        role: PropTypes.number,
    }),
    onDeleted: PropTypes.func,
    ...WithProcessError.propTypes,
};

export default WithProcessError(TeamMember);
